<ng-container *ngIf="video">
  <div id="VideoContainer"
       [style.width.px]="_width"
       [style.height.px]="_height"
       [style.max-height.px]="(_width / video.videoWidth) * video.videoHeight"
       (mousemove)="AfficheControleBar()" (mouseleave)="HideControleBar()" #VideoContainer>


    <canvas id="leCanvas" style="border-style:solid;" (click)="TooglePlay(); AfficheMoreOptions(false);" (dblclick)="ToogleFullScreen()" #Canvas>Canvas non supportee</canvas>
    <div class="backward" (dblclick)="OnStepCurrentTime(false)"></div>
    <div class="forward" (dblclick)="OnStepCurrentTime(true)"></div>
    <div *ngIf="isPlaying" class="big-play row h-100 q-c-main event-none">
      <i class="fas fa-play d-flex col-12 justify-content-center align-items-center" [style.font-size.px]=" _height > _width ? _width / 5 : _height / 5"></i>
    </div>



    <div *ngIf="!isPlaying" class="row position-absolute w-100 h-100 q-c-main event-none">
      <i *ngIf="!isEnded && isFirstPlaying" class="fas fa-play d-flex col-12 justify-content-center align-items-center" [style.font-size.px]=" _height > _width ? _width / 5 : _height / 5"></i>
      <i *ngIf="isEnded" class="fas fa-redo-alt fa-flip-horizontal d-flex col-12 justify-content-center align-items-center" [style.font-size.px]=" _height > _width ? _width / 5 : _height / 5"></i>
    </div>

    <div *ngIf="isVideoContainerLoaded" id="ControlBarContainer" class="w-100" (mouseenter)="isControlBarHover = true;" (mouseleave)="isControlBarHover = false;" #ControlBarContainer>
      <div class="controler-container">

        <!--arrière-->
        <button (click)="OnStepCurrentTime(false)" class="btn-controleur m-0"><i class="fas fa-backward"></i></button>

        <!--play-->
        <button *ngIf="!isPlaying" (click)="OnPlay(); AfficheMoreOptions(false);" class="btn-controleur m-0">
          <i *ngIf="!isEnded" class="fas fa-play"></i>
          <i *ngIf="isEnded" class="fas fa-redo-alt fa-flip-horizontal"></i>
        </button>
        <!--pause-->
        <button *ngIf="isPlaying" (click)="OnPause(); AfficheMoreOptions(false);" class="btn-controleur m-0"><i class="fas fa-pause"></i></button>
        <!--avant-->
        <button (click)="OnStepCurrentTime(true)" class="btn-controleur"><i class="fas fa-forward"></i></button>

        <!--barre de défilement-->
        <div id="sliderContainer" class="d-flex flex-grow-1 align-items-center mr-3" [ngClass]="{'slide-bar-above': videoContainer.nativeElement.clientWidth < 700}">
          <input #rangeEl #slider class="custom-slider custom-slider-bullet reader"
                 type="range" id="slider" name="progressBar"
                 [min]="0" [max]="video.duration"
                 [(ngModel)]="video.currentTime"
                 (mousemove)="AfficheTitle($event)"
                 (click)="AffectTitle(); AfficheMoreOptions(false);"
                 (keydown)="$event.preventDefault()" />
          <div id="sliderHover" [style.width.%]=""></div>
          <span #sliderTitle id="slidertitle" class="q-dark-main p-1 rounded">{{hoverTime | hourMinuteSec : video.duration > 3600}}</span>
        </div>

        <div class="timer">{{video.currentTime | hourMinuteSec : video.duration > 3600}}</div>
        <div class="timer">/</div>
        <div class="timer mr-3">{{video.duration | hourMinuteSec}}</div>

        <!--volume-->
        <div id="volume-container" [style.maxWidth.%]="videoContainer.nativeElement.clientWidth >= 700 ? 12 : 20">
          <!--bouton volume-->
          <button *ngIf="!video.muted" (click)="OnMute(); AfficheMoreOptions(false);" class="btn-controleur mr-0">
            <i *ngIf="video.volume < 0.5 && video.volume > 0" class="fas fa-volume-down"></i>
            <i *ngIf="video.volume >= 0.5" class="fas fa-volume-up"></i>
            <i *ngIf="video.volume === 0" class="fas fa-volume-off"></i>
          </button>
          <!--bouton volume muted-->
          <button *ngIf="video.muted" (click)="OnMute(); AfficheMoreOptions(false);" class="btn-controleur mr-0"><i class="fas fa-volume-mute"></i></button>
          <!--jauge de volume-->
          <div id="input-volume-container">
            <input #rangeEl #inputVolume
                   class="custom-slider custom-slider-bullet"
                   type="range" name="volumeControler" [min]="0.0" [max]="1.0" [(ngModel)]="video.volume" [step]="0.01"
                   (mouseenter)="FocusVolumeInput()" (click)="FocusVolumeInput()"
                   (mouseleave)="UnfocusVolumeInput()"
                   (keydown)="$event.preventDefault()"
                   (change)="OnVolumeChange($event.target.value)" />
          </div>
        </div>

        <!--pleinécran-->
        <button *ngIf="!isFullScreen && !video.src.endsWith('mp3')" (click)="OnFullScreen()" class="btn-controleur ml-auto"><i class="fas fa-expand"></i></button>
        <button *ngIf="isFullScreen" (click)="OnCloseFullscreen()" class="btn-controleur"><i class="fas fa-compress"></i></button>

        <!--options-->
        <button (click)="AfficheMoreOptions(!isMoreOptionsVisible);" class="btn-controleur"> <i class="fas fa-cog"></i></button>
        <!--modal options-->
        <div *ngIf="isMoreOptionsVisible" id="moreOptions" class="option-container" [style.max-height.px]="_height - 60">
          <!--panneau par défaut-->
          <ng-container *ngIf="selectedOptionPanel === 'default'">
            <!--bouton vitesse de lecture-->
            <button (click)="selectedOptionPanel = 'speed'" class="default-button speed-container d-flex option-button">
              <div class="mr-auto">vitesse</div>
              <div class="ml-auto">{{video.playbackRate === 1 ? 'normale' : 'x' + video.playbackRate}}</div>
            </button>
          </ng-container>

          <!--panneau de choix de vitesse de lecture-->
          <ng-container *ngIf="selectedOptionPanel === 'speed'">
            <div class="d-flex">
              <button (click)="selectedOptionPanel = 'default'" class="option-button d-flex"><i class="fas fa-chevron-left"></i></button>
              <div class="title-vitesse">Vitesse</div>
            </div>
            <hr />
            <button (click)="OnSpeedChange(0.25)" class="specific-button option-button">x0.25</button>
            <button (click)="OnSpeedChange(0.5)" class="specific-button option-button">x0.5</button>
            <button (click)="OnSpeedChange(0.75)" class="specific-button option-button">x0.75</button>
            <button (click)="OnSpeedChange(1)" class="specific-button option-button">normale</button>
            <button (click)="OnSpeedChange(1.25)" class="specific-button option-button">x1.25</button>
            <button (click)="OnSpeedChange(1.5)" class="specific-button option-button">x1.5</button>
            <button (click)="OnSpeedChange(1.75)" class="specific-button option-button">x1.75</button>
            <button (click)="OnSpeedChange(2)" class="specific-button option-button">x2</button>
          </ng-container>
        </div>

      </div>
    </div>
  </div>

</ng-container>
